export default "__VITE_ASSET__CmFFegCu__"